import { SvgIcon } from "@/components/icon"
import { Button } from "antd"
import { CarouselRef } from "antd/es/carousel"
import { CSSProperties, forwardRef } from "react"

interface Props {
  ref : React.MutableRefObject<CarouselRef | null>
  type: 'prev' | 'next'
}

export const ArrowButton = forwardRef<CarouselRef, Props>(
  ({ type }, ref) => {
    const onClick = () => {
      const carousel = (ref as React.MutableRefObject<CarouselRef>).current;
      if (type === 'prev') {
        carousel.prev()
      } else {
        carousel.next()
      }
    }

    const style: CSSProperties = {
      width: 48,
      height: 48,
      background: '#F8F8F8',
      borderRadius: '50%',
      padding: 0,
      border: 'none',
      boxShadow: 'none',
    }

    return (
      <Button onClick={onClick} style={style}>
        {type === 'prev'
          ? <SvgIcon type={'arrowRightOutlined'} />
          : <SvgIcon type={'arrowLeftOutlined'} />
        }
      </Button>
    )
  }
)


ArrowButton.displayName = "ArrowButton";